module.exports = __webpack_public_path__ + "img/title_speech.67a94388.png";